































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import RoleRequest from "@/models/security/roleRequest.model";
import { UserType } from "@/enums/UserType";
import { RowTable } from "@/typings/BRowTable";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import { PermissionValue } from "@/enums/PermissionValue";

@Component({
  components: {
    UserBasicInformationComponent,
    ResearchCenterBasicInformationComponent
  }
})
export default class AdminRoleRequestTable extends GenericBTable<RoleRequest> {
  created() {
    this.permissionValue = PermissionValue.SOLICITUDROLE;
    this.tableConfig.controller = "RoleRequest/admin";
    this.tableConfig.actions.customTemplate = true;
  }

  get user() {
    return this.$store.state.user;
  }
  
  mounted() {
    //this.permissionAccess.view = true;
    //this.permissionAccess.write = true;
    //this.permissionAccess.managment = true;
    //this.permissionAccess.permissionAccessLevel = true;
    this.formatColumns();
  }

  add() {
    this.$store.commit("setOpenAddRequesRoleModal", true);
  }

  view(id: number, data: RoleRequest, props: RowTable<RoleRequest>) {
    this.$router.push(`${this.$router.currentRoute.path}/view/${id}`);
  }

  aprove(roleRequest: RoleRequest) {}

  formatColumns() {
    let user = new BTableColumn("user", "table.user", true);
    user.customTemplate = true;
    let userType = new BTableColumn(
      "userTypeDescription",
      "table.userType",
      true
    );

    this.tableConfig.enableDefaultColumns = false;

    let researchCenterDescription = new BTableColumn(
      "researchCenterDescription",
      "table.institutions",
      true
    );

    let roleRequestStatus = new BTableColumn(
      "roleRequestStatusDescription",
      "table.roleRequestStatus",
      true
    );

    researchCenterDescription.customTemplate = true;
    // researchType.customTemplate = true;
    this.tableConfig.insertColumns(
      user,
      userType,
      researchCenterDescription,
      roleRequestStatus
    );

    this.tableConfig.activeActions = this.permissionAccess.managment;
    this.tableConfig.actions.customTemplate = this.permissionAccess.managment;

  }
}
